import { useState, useCallback } from 'react';
import api from '../services/api';

export function usePaymentForm({ onError }) {
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState('');

  const initializePayment = useCallback(async (amount) => {
    setIsProcessing(true);
    setError('');

    try {
      // Step 1: Call Laravel API to initiate checkout
      const response = await api.post('/initiatePayment', { amount });
      
      if (!response.data?.sessionId) {
        throw new Error('Invalid response from server');
      }

      const sessionId = response.data.sessionId;
      console.log(sessionId)
      // Step 2: Load Mastercard Hosted Checkout script
      const script = document.createElement("script");
      script.src = "https://ap-gateway.mastercard.com/static/checkout/checkout.min.js";
      // script.src = "https://test-gateway.mastercard.com/static/checkout/checkout.min.js";
      script.async = true;

      script.onload = () => {
        // Step 3: Configure Mastercard Hosted Checkout with session ID
        Checkout.configure({
          session: {
            id: sessionId
          }
        });

        // Step 4: Redirect user to Mastercard Hosted Checkout
        Checkout.showPaymentPage();
      };

      script.onerror = () => {
        setError('Failed to load Mastercard payment script.');
        onError?.(new Error('Failed to load Mastercard payment script.'));
      };

      document.body.appendChild(script);
    } catch (err) {
      console.error(err);
      setError('Failed to initialize payment. Please try again.');
      onError?.(err);
    } finally {
      setIsProcessing(false);
    }
  }, [onError]);

  return {
    isProcessing,
    error,
    initializePayment,
  };
}
